
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storagecontainerprices/contact-us",
      function () {
        return require("private-next-pages/storagecontainerprices/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storagecontainerprices/contact-us"])
      });
    }
  